import { useState } from "react";
import { useApp } from "@/contexts/AppContext";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const { login } = useApp();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const success = await login(username, password);
      if (success) {
        navigate("/dashboard");
      } else {
        setError("Invalid username or password");
      }
    } catch (error) {
      setError(error.message || "Login failed. Please try again.");
    }
  };

  const inputClass =
    "w-full rounded-(--radius-md) border border-(--border-subtle) bg-(--surface-1) px-3 py-2 text-[14px] text-(--text-primary) outline-none transition-colors placeholder:text-(--text-muted) focus:border-(--brand-primary)";

  return (
    <div className="flex min-h-screen items-center justify-center bg-(--surface-2) px-4">
      <div className="w-full max-w-[400px] rounded-(--radius-lg) bg-(--surface-1) px-8 py-10">
        <div className="mb-8 text-center">
          <h1 className="text-2xl font-bold text-(--text-primary)">Adlywise</h1>
          <p className="mt-1 text-[13px] text-(--text-muted)">
            CTV/OTT Advertising Network
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <label className="block space-y-1.5">
            <span className="text-[12px] font-semibold text-(--text-secondary)">
              Username
            </span>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter username"
              required
              autoComplete="username"
              className={inputClass}
            />
          </label>

          <label className="block space-y-1.5">
            <span className="text-[12px] font-semibold text-(--text-secondary)">
              Password
            </span>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              required
              autoComplete="current-password"
              className={inputClass}
            />
          </label>

          <button
            type="submit"
            className="mt-2 inline-flex h-11 w-full items-center justify-center rounded-(--radius-md) border-0 bg-(--brand-primary) text-[14px] font-bold text-(--brand-primary-contrast) transition-colors hover:bg-(--brand-primary-hover)"
          >
            Sign In
          </button>

          {error && (
            <div className="rounded-(--radius-md) bg-(--pastel-rose) px-3 py-2 text-center text-[13px] font-semibold text-(--status-danger)">
              {error}
            </div>
          )}
        </form>
      </div>
    </div>
  );
}
